/**
 * 再資源化
 * 処分方法
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";
import * as types from "../../../mutation-types/driver-types";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/recycle_disposal_methods`;

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0,
    },
    condition: {
      name: null,
      primary_after_disposal_method_id: null,
      after_disposal_method_ids: [],
      without_invisible: true,
      limit: 50,
    },
  };
};

const master_recycle_disposal_method = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {

    index ({ dispatch, commit, state }, { name, primary_after_disposal_method_id, after_disposal_method_ids, without_invisible, page, limit, format, useState = true }) {
      if (useState) {
        dispatch("saveCondition", { name: name, primary_after_disposal_method_id: primary_after_disposal_method_id, after_disposal_method_ids: after_disposal_method_ids, without_invisible: without_invisible, limit: limit });
      }

      let api_path

      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = API_PATH
      }

      const params = { name: name, primary_after_disposal_method_id: primary_after_disposal_method_id, after_disposal_method_ids: after_disposal_method_ids, without_invisible: without_invisible, page: page, limit: limit }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format !== 'csv') {
            let content = data.content
            if (useState) {
              commit(types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_PAGINATION, { content })
            }
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/new`).then(data => {
          let content = data.content
          resolve(content)
        })
      });
    },
    edit ({ commit }, { id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}`).then(data => {
          let content = data.content
          resolve(content)
        })
      });
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        const content = {};
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const content = {};
        Vue.$http.put(`${API_PATH}/${id}`, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    destroy ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        let content = {};
        Vue.$http.delete(`${API_PATH}/${id}`).then(data => {
          let content = data.content;
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(content)
        })
      })
    },
    /**
     * 検索条件の保存
     * @param commit
     * @param state
     * @param name
     * @param primary_after_disposal_method_id
     * @param after_disposal_method_ids
     * @param without_invisible
     * @param limit
     */
    saveCondition ( { commit, state }, { name, primary_after_disposal_method_id, after_disposal_method_ids, without_invisible, limit } = {} ) {
      const _name = (name !== undefined) ? name : state.condition.name;
      const _primary_after_disposal_method_id = (primary_after_disposal_method_id !== undefined) ? primary_after_disposal_method_id : state.condition.primary_after_disposal_method_id;
      const _after_disposal_method_ids = (after_disposal_method_ids !== undefined) ? after_disposal_method_ids : state.condition.after_disposal_method_ids;
      const _without_invisible = (without_invisible !== undefined) ? without_invisible : state.condition.without_invisible
      const _limit = (limit !== undefined) ? limit : state.condition.limit;
      const params = { name: _name, primary_after_disposal_method_id: _primary_after_disposal_method_id, after_disposal_method_ids: _after_disposal_method_ids, without_invisible: _without_invisible, limit: _limit}
      commit(types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_CONDITION, { params })
    },
    /**
     * 保存された検索条件のクリア
     * @param commit
     */
    resetState({ commit }) {
      commit(types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_CONDITION);
    },
    /**
     * 保存されたページ情報のクリア
     * @param commit
     */
    resetPagination({ commit }) {
      commit(types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_PAGINATION);
    },
  },
  mutations: {
    [types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_CONDITION](state, { params }) {
      Object.assign(state.condition, params);
    },
    [types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_CONDITION](state) {
      Object.assign(state, getDefaultState());
    },
    [types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_PAGINATION](state, { content }) {
      state.pagination = content.pagination;
    },
    [types.DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_PAGINATION](state) {
      Object.assign(state.pagination, getDefaultState().pagination);
    },
  },
};

export default master_recycle_disposal_method;
